export default {
  most_popular: '#{{rank}} Najbardziej lubiany',
};
